import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer({ showmap, child }) {

    return (
        <div>
            <iframe className={!showmap ? "d-none" : ""} width="100%" title='Map' height="300" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=es&amp;q=Gómez+Farias+212,+Zona+Centro,+31000+Chihuahua,+Chih.&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
            </iframe>
            <img src={child ? "../linea-de-color.jpg" : "linea-de-color.jpg"} alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "-17px" }} />
            <div className="text-center p-2" style={{ background: "#002d7e", color: "white" }}>
                <h4>
                    <Link className='noLink' style={{ color: "white" }} to="/avisoprivacidad">Aviso de Privacidad Integral</Link>  |  <Link className='noLink' style={{ color: "white" }} to="/avisoprivacidadsimplificado">Aviso de Privacidad Simplificado</Link></h4>
            </div>
            <img src={child ? "../footer.png" : "footer.png"} alt="" className='img-fluidOther' />
        </div >
    )
}
